import { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { EDU_LEGAL_DOCS, EDU_LEGAL_VERSION } from "../content/eduLegal";

export default function EduLegalPage({ doc }) {
  const [lang, setLang] = useState("pl");
  const d = EDU_LEGAL_DOCS[doc];
  if (!d) return null;
  return (
    <div className="mx-auto max-w-3xl px-4 py-10" data-testid={`edu-legal-${doc}`}>
      <Helmet><title>{`${d.title.pl} — PlanGmina EDU`}</title></Helmet>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <h1 className="max-w-xl text-2xl font-bold text-slate-900">{d.title[lang]}</h1>
        <div className="flex gap-1 rounded-lg border border-slate-300 p-0.5 text-xs font-semibold" data-testid="edu-legal-lang-switch">
          <button onClick={() => setLang("pl")} data-testid="edu-legal-lang-pl"
            className={`rounded-md px-3 py-1 ${lang === "pl" ? "bg-slate-900 text-white" : "text-slate-600"}`}>PL</button>
          <button onClick={() => setLang("en")} data-testid="edu-legal-lang-en"
            className={`rounded-md px-3 py-1 ${lang === "en" ? "bg-slate-900 text-white" : "text-slate-600"}`}>EN</button>
        </div>
      </div>
      <p className="mt-1 text-xs text-slate-500" data-testid="edu-legal-version">
        {lang === "pl"
          ? `Wersja: ${EDU_LEGAL_VERSION} · wersja polska jest wiążąca w razie rozbieżności`
          : `Version: ${EDU_LEGAL_VERSION} · the Polish version prevails in case of discrepancies`}
      </p>
      {d.sections.map((s, i) => (
        <section key={i} className="mt-7" data-testid={`edu-legal-${doc}-s${i}`}>
          <h2 className="text-base font-bold text-slate-900">{s.heading[lang]}</h2>
          <ol className="mt-2 list-decimal space-y-1.5 pl-5 text-sm leading-relaxed text-slate-700">
            {s.items[lang].map((p, j) => <li key={j}>{p}</li>)}
          </ol>
        </section>
      ))}
      <p className="mt-10 border-t border-slate-200 pt-4 text-xs text-slate-500">
        <Link to="/edu" className="underline" data-testid={`edu-legal-${doc}-back`}>PlanGmina EDU</Link>
        {" · "}
        <Link to="/edu/regulamin" className="underline" data-testid={`edu-legal-${doc}-link-regulamin`}>Regulamin</Link>
        {" · "}
        <Link to="/edu/prywatnosc" className="underline" data-testid={`edu-legal-${doc}-link-prywatnosc`}>Dane osobowe</Link>
        {" · "}
        <Link to="/edu/retencja" className="underline" data-testid={`edu-legal-${doc}-link-retencja`}>Retencja</Link>
      </p>
    </div>
  );
}
